const panels = Array.from(document.querySelectorAll(".panel"));
const navLinks = document.querySelectorAll(".nav-link[data-panel]");
let currentIndex = 0;
let isTransitioning = false;
let tokenomicsAnimated = false;
let kpiAnimated = false;
let heroTypewriterStarted = false;

const tokenomicsData = [
    { label: "Token Sale", value: 30, color: "#e70e0e" },
    { label: "Marketing", value: 30, color: "#fb923c" },
    { label: "Community", value: 15, color: "#facc15" },
    { label: "Team and Advisors", value: 10, color: "#22c55e" },
    { label: "Reserve", value: 10, color: "#0ea5e9" },
    { label: "Liquidity", value: 5, color:"#904de7"}
];

// NAVBAR HEIGHT SYNC
const navbar = document.querySelector(".navbar");

function syncNavbarHeight() {
    if (!navbar) return;
    const isOpen = document.body.classList.contains("nav-open");
    const extraHeight = isOpen ? 300 : 0;
    document.documentElement.style.setProperty("--navbar-open-offset", extraHeight + "px");
}

if (navbar) {
    new ResizeObserver(syncNavbarHeight).observe(navbar);
}
syncNavbarHeight();

// URL Router
function getRouteFromPath() {
    const path = window.location.pathname.replace(/^\/+|\/+$/g, "");
    return path === "" ? "home" : path;
}

function navigateToPanel(panelId, push = true) {
    const index = panels.findIndex((p) => p.id === panelId);
    if (index !== -1) {
        showSection(index, push);
    }
}

function initRouter() {
    const route = getRouteFromPath();
    navigateToPanel(route, false);
}

window.addEventListener("popstate", () => {
    const route = getRouteFromPath();
    navigateToPanel(route, false);
});

window.addEventListener("load", () => {
    initRouter();
});

/* LANGUAGE SWITCH LOGIC */
const langButtons = document.querySelectorAll(".lang-btn");

function attachPanelTriggers() {
    const panelButtons = document.querySelectorAll("[data-panel-trigger]");
    panelButtons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            const targetId = btn.getAttribute("data-panel-trigger");
            const index = panels.findIndex((p) => p.id === targetId);
            if (index !== -1) {
                showSection(index);
            }
        });
    });
}

// Update all texts in the page based on lang
function updateTexts(lang) {
    const textAttr = lang === "de" ? "data-i18n-de" : "data-i18n-en";
    const placeholderAttr =
        lang === "de" ? "data-i18n-placeholder-de" : "data-i18n-placeholder-en";
    const tosLink = document.getElementById("tos")

    if (lang === "de") {
        tosLink.href = "/pdf/agb.pdf";
    } else {
        tosLink.href = "/pdf/tos.pdf"
    }
    // Update all textual content
    document.querySelectorAll("[data-i18n-de]").forEach((el) => {
        const value = el.getAttribute(textAttr);
        if (value !== null) el.innerHTML = value;
    });

    // Update placeholders
    document.querySelectorAll("[data-i18n-placeholder-de]").forEach((el) => {
        const value = el.getAttribute(placeholderAttr);
        if (value !== null) el.placeholder = value;
    });

    document.documentElement.lang = lang;
    attachPanelTriggers();
}

// Update a <select> dynamically: text + sorted order
function updateSelectLanguage(selectId, lang) {
    const select = document.getElementById(selectId);
    if (!select) return;

    // Update option text
    Array.from(select.options).forEach((opt) => {
        const newText = opt.getAttribute(`data-i18n-${lang}`);
        if (newText) opt.textContent = newText;
    });

    // Sort options (except the disabled placeholder)
    const placeholder = select.querySelector("option[disabled]");
    const optionsToSort = Array.from(select.options).filter(
        (opt) => !opt.disabled,
    );

    optionsToSort.sort((a, b) => {
        const aText = a.getAttribute(`data-i18n-${lang}`);
        const bText = b.getAttribute(`data-i18n-${lang}`);
        return aText.localeCompare(bText, lang === "de" ? "de" : "en", {
            sensitivity: "base",
        });
    });

    // Reattach options in correct order
    if (placeholder) select.appendChild(placeholder); // placeholder stays first
    optionsToSort.forEach((opt) => select.appendChild(opt));
}

// Set language: update texts + update select dynamically
function setLanguage(lang) {
    langButtons.forEach((btn) => {
        btn.classList.toggle("active", btn.dataset.lang === lang);
    });
    updateTexts(lang);
    updateSelectLanguage("customer-language", lang);
}

// Initialize language
(function initLanguage() {
    const stored = localStorage.getItem("evocare-lang");
    let initialLang = stored || "de";
    if (!stored) {
        const browserLang = (
            navigator.language ||
            (navigator.languages && navigator.languages[0]) ||
            "en"
        ).toLowerCase();
        initialLang = browserLang.startsWith("de") ? "de" : "en";
    }
    setLanguage(initialLang);

    langButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            const lang = btn.dataset.lang;
            setLanguage(lang);
            localStorage.setItem("evocare-lang", lang);
        });
    });
})();

function setActiveNav(id) {
    navLinks.forEach((link) => {
        const panelId = link.getAttribute("data-panel");
        link.classList.toggle("active", panelId === id);
    });
}

function animateTeamCards(panel) {
    const cards = panel.querySelectorAll(".team-card");
    cards.forEach((card) => card.classList.remove("visible"));
    cards.forEach((card, i) => {
        setTimeout(() => {
            card.classList.add("visible");
        }, i * 180);
    });
}

function shadeColor(hex, percent) {
    let c = hex.replace("#", "");
    if (c.length === 3) {
        c = c
            .split("")
            .map((ch) => ch + ch)
            .join("");
    }
    const num = parseInt(c, 16);
    let r = (num >> 16) & 255;
    let g = (num >> 8) & 255;
    let b = num & 255;
    r = Math.min(255, Math.max(0, r + (r * percent) / 100));
    g = Math.min(255, Math.max(0, g + (g * percent) / 100));
    b = Math.min(255, Math.max(0, b + (b * percent) / 100));
    const toHex = (v) => v.toString(16).padStart(2, "0");
    return (
        "#" + toHex(Math.round(r)) + toHex(Math.round(g)) + toHex(Math.round(b))
    );
}

function drawTokenomicsChart() {
    const canvas = document.getElementById("tokenomicsChart");
    if (!canvas || !canvas.getContext) return;
    const ctx = canvas.getContext("2d");
    const cw = canvas.width;
    const ch = canvas.height;
    const cx = cw / 2;
    const cy = ch / 2;
    const radius = Math.min(cx, cy) - 8;
    const innerRadius = radius * 0.6;
    const total = tokenomicsData.reduce((sum, d) => sum + d.value, 0);
    const startAngleBase = -Math.PI / 2;
    const totalDuration = 1500;
    const startTime = performance.now();

    function frame(now) {
        const elapsed = now - startTime;
        const progress = Math.min(1, elapsed / totalDuration);
        ctx.clearRect(0, 0, cw, ch);

        const maxAngle = 2 * Math.PI * progress;
        let angle = startAngleBase;
        let remaining = maxAngle;

        ctx.save();
        ctx.shadowColor = "rgba(15, 23, 42, 0.55)";
        ctx.shadowBlur = 18;
        ctx.shadowOffsetY = 6;

        tokenomicsData.forEach((d) => {
            const fullSlice = (2 * Math.PI * d.value) / total;
            const sliceAngle = Math.min(fullSlice, Math.max(0, remaining));
            if (sliceAngle > 0) {
                const grad = ctx.createLinearGradient(
                    0,
                    cy - radius,
                    0,
                    cy + radius,
                );
                grad.addColorStop(0, shadeColor(d.color, 20));
                grad.addColorStop(1, shadeColor(d.color, -25));
                ctx.beginPath();
                ctx.arc(cx, cy, radius, angle, angle + sliceAngle);
                ctx.arc(cx, cy, innerRadius, angle + sliceAngle, angle, true);
                ctx.closePath();
                ctx.fillStyle = grad;
                ctx.fill();
                remaining -= sliceAngle;
            }
            angle += sliceAngle;
        });

        ctx.restore();
        ctx.globalCompositeOperation = "destination-out";
        ctx.beginPath();
        ctx.arc(cx, cy, innerRadius, 0, 2 * Math.PI);
        ctx.fill();
        ctx.globalCompositeOperation = "source-over";

        if (progress < 1) {
            requestAnimationFrame(frame);
        }
    }

    requestAnimationFrame(frame);
}

function animateTokenomics() {
    if (tokenomicsAnimated) return;
    tokenomicsAnimated = true;
    drawTokenomicsChart();
}

function animateKpis() {
    if (kpiAnimated) return;
    kpiAnimated = true;
    const kpis = document.querySelectorAll(".platform-kpi-value");
    kpis.forEach((kpi) => {
        const targetStr = kpi.getAttribute("data-target") || "0";
        const initialText = kpi.textContent.trim();
        const endsPercent = initialText.endsWith("%");
        const endsTimes = initialText.endsWith("×");
        const target = parseFloat(targetStr);
        if (isNaN(target)) return;
        const duration = 1200;
        const startTime = performance.now();

        function update(now) {
            const elapsed = now - startTime;
            const progress = Math.min(1, elapsed / duration);
            const value = Math.floor(target * progress);
            if (endsPercent) {
                kpi.textContent = value + "%";
            } else if (endsTimes) {
                kpi.textContent = value + "×";
            } else {
                kpi.textContent = value;
            }
            if (progress < 1) {
                requestAnimationFrame(update);
            }
        }

        requestAnimationFrame(update);
    });
}

// HERO VIDEO + TYPEWRITER
let heroVideo = null;
const heroMedia = document.querySelector(".hero-media");

function startHeroTypewriter() {
    const titleMain = document.getElementById("heroTitleText");
    const subtitle = document.querySelector(".hero-subtitle");
    const dot = document.querySelector(".hero-title-accent-dot");

    if (!titleMain || !subtitle || !dot) return;

    const lang = document.documentElement.lang === "en" ? "en" : "de";
    const attr = lang === "de" ? "data-i18n-de" : "data-i18n-en";
    const fullRaw =
        titleMain.getAttribute(attr) || titleMain.textContent.trim();

    const fullText = fullRaw.replace(/[.。•●]+$/g, "");

    titleMain.textContent = "";
    subtitle.classList.remove("visible");
    subtitle.style.visibility = "hidden";
    dot.classList.remove("visible");

    let index = 0;
    const interval = 40;

    function step() {
        if (index <= fullText.length) {
            titleMain.textContent = fullText.slice(0, index);
            index += 1;
            setTimeout(step, interval);
        } else {
            dot.classList.add("visible");
            setTimeout(() => {
                subtitle.classList.add("visible");
                subtitle.style.visibility = "visible";
            }, 150);
        }
    }
    step();
}

function showHeroContent() {
    const heroContent = document.querySelector(".hero-content");
    if (heroContent) {
        heroContent.classList.add("visible");
    }
    if (!heroTypewriterStarted) {
        heroTypewriterStarted = true;
        startHeroTypewriter();
    } else {
        const subtitle = document.querySelector(".hero-subtitle");
        const dot = document.querySelector(".hero-title-accent-dot");
        if (dot) dot.classList.add("visible");
        if (subtitle) {
            subtitle.classList.add("visible");
            subtitle.style.visibility = "visible";
        }
    }
}

function createHeroVideo() {
    if (heroVideo || !heroMedia) return heroVideo;

    const video = document.createElement("video");
    video.id = "heroVideo";
    video.muted = true;
    video.playsInline = true;
    video.preload = "metadata";
    video.disablePictureInPicture = true;
    video.style.opacity = "0";

    heroMedia.appendChild(video);
    heroVideo = video;
    return heroVideo;
}

function playHeroVideo() {
    const homePanel = document.getElementById("home");
    if (!homePanel || !homePanel.classList.contains("active")) return;

    const video = createHeroVideo();
    if (!video) return;

    video.src = "/video/intro1.mp4";
    video.load();

    video.oncanplay = () => {
        video.style.opacity = "1";
        video.play().catch(showHeroContent);
    };

    video.onended = () => {
        video.style.opacity = "0";
        setTimeout(() => {
            stopHeroVideo();
            showHeroContent();
        }, 300);
    };
}

function stopHeroVideo() {
    if (!heroVideo) return;

    heroVideo.pause();
    heroVideo.removeAttribute("src");
    heroVideo.load();

    heroVideo.remove();
    heroVideo = null;
}

function stopPanelVideos(panel) {
    if (!panel) return;

    const videos = panel.querySelectorAll("video");

    videos.forEach((video) => {
        try {
            video.pause();
            video.currentTime = 0;

            if (video.hasAttribute("data-src")) {
                video.removeAttribute("src");
                video.load();
            }
        } catch (_) {}
    });
}

function handlePanelVideos(panel) {
    if (!panel) return;

    const videos = panel.querySelectorAll("video[data-src]");

    videos.forEach((video) => {
        if (!video.src) {
            video.src = video.dataset.src;
            video.load();

            if (video.hasAttribute("autoplay") || video.muted) {
                video.play().catch(() => {
                    console.log(
                        "Video autoplay blocked, requires user interaction.",
                    );
                });
            }
        }
    });
}

function showSection(index, pushState = true) {
    if (index < 0 || index >= panels.length) return;

    if (isTransitioning) return;
    let hasInitialRouteRun = false;
    if (index === currentIndex && hasInitialRouteRun) return;
    isTransitioning = true;

    const oldPanel = panels[currentIndex];
    const newPanel = panels[index];

    oldPanel.classList.remove("active");
    newPanel.classList.add("active");
    newPanel.scrollTop = 0;

    currentIndex = index;
    setActiveNav(newPanel.id);

    if (pushState) {
        const url = newPanel.id === "home" ? "/" : `/${newPanel.id}`;
        history.pushState(null, "", url);
    }

    if (newPanel.id === "home") {
        playHeroVideo();
    } else {
        stopHeroVideo();
    }

    // panel-specific hooks
    if (newPanel.id === "team") animateTeamCards(newPanel);
    if (newPanel.id === "investors") animateTokenomics();
    if (newPanel.id === "platform") animateKpis();

    stopPanelVideos(oldPanel);
    handlePanelVideos(newPanel);

    setTimeout(() => {
        isTransitioning = false;
        hasInitialRouteRun = true;
    }, 800);
}

// Navigation Klicks
navLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = link.getAttribute("data-panel");
        navigateToPanel(targetId);
    });
});

// MOBILE HAMBURGER MENU
const navToggle = document.querySelector(".nav-toggle");
const navLinksContainer = document.querySelector(".nav-links");

if (navToggle && navLinksContainer) {
    navToggle.addEventListener("click", () => {
        const isOpen = navLinksContainer.classList.toggle("open");
        navToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        document.body.classList.toggle("nav-open", isOpen);
    });

    navLinks.forEach((link) => {
        link.addEventListener("click", () => {
            if (navLinksContainer.classList.contains("open")) {
                navLinksContainer.classList.remove("open");
                document.body.classList.remove("nav-open");
                navToggle.setAttribute("aria-expanded", "false");
            }
        });
    });
}